import script from "./summary.vue?vue&type=script&setup=true&lang=js"
export * from "./summary.vue?vue&type=script&setup=true&lang=js"

import "./summary.vue?vue&type=style&index=0&id=739102d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739102d4"]])

export default __exports__